<template>
  <div :class="$style.quantity">
    <BaseButton
      :class="$style['quantity-button']"
      class="mx-2"
      type="primary"
      :outlined="true"
      :small="true"
      :width="defaultButtonSize"
      :height="defaultButtonSize"
      :disabled="disable || currentQuantity === min"
      :tabindex="doNotFocusButtons ? '-1' : undefined"
      @click.native="decreaseQuantity"
    >
      <span :class="[$style['quantity-label'], $style['decrease']]"></span>
    </BaseButton>
    <slot v-bind="{ currentQuantity }">
      <v-text-field
        v-model="currentQuantity"
        v-bind="$attrs"
        :min="min"
        :max="max"
        :disable="disable"
      />
    </slot>
    <BaseButton
      :class="$style['quantity-button']"
      class="mx-2"
      type="primary"
      :outlined="true"
      :small="true"
      :width="defaultButtonSize"
      :height="defaultButtonSize"
      :disabled="disable || currentQuantity >= max"
      :tabindex="doNotFocusButtons ? '-1' : undefined"
      @click.native="increaseQuantity"
    >
      <span :class="[$style['quantity-label'], $style['increase']]"></span>
    </BaseButton>
  </div>
</template>

<script>
// import { debounce } from 'lodash-es'

const min = 1

export default {
  name: 'QuantityButtons',
  props: {
    value: {
      type: [Number, String],
      default: min,
    },
    disable: {
      type: Boolean,
      default: false,
    },
    max: {
      type: Number,
      default: 999,
    },
    actionCounter: {
      type: Number,
      default: 0,
    },
    min: {
      type: Number,
      default: min,
    },
    doNotFocusButtons: {
      type: Boolean,
      default: false,
    },
    showMax: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      currentQuantity: this.value,
      defaultButtonSize: 24,
    }
  },
  computed: {
    currentQuantityValue() {
      return parseInt(this.currentQuantity, 10) || 0
    },
  },
  watch: {
    currentQuantity(newValue) {
      const finalValue = this.calculateValue(newValue)
      if (this.value !== finalValue) {
        // this.updateQuantityDebounced(finalValue)
        this.updateQuantity(finalValue)
      }
    },
    value: {
      handler(newValue) {
        const finalValue = this.calculateValue(newValue)

        if (this.currentQuantityValue !== finalValue) {
          this.currentQuantity = finalValue
        }
        if (this.value !== finalValue) {
          this.$emit('input', finalValue)
        }
      },
      immediate: true,
    },
    max: {
      handler() {
        if (this.currentQuantityValue > this.max) {
          this.currentQuantity = this.max
        }
      },
      immediate: true,
    },
    actionCounter() {
      this.currentQuantity = this.value
    },
  },
  // created() {
  //   this.updateQuantityDebounced = debounce(this.updateQuantity, 50)
  // },
  methods: {
    calculateValue(newValue) {
      let finalValue = newValue

      if (finalValue > this.max) {
        finalValue = this.max
      }

      if (finalValue < this.min && this.min >= this.max) {
        finalValue = this.min
      }
      // console.log({ finalValue })
      return finalValue
    },
    updateQuantity(qty) {
      // console.log('input', qty)
      this.$emit('input', qty)
    },
    increaseQuantity() {
      this.currentQuantity = this.readOnly
        ? this.currentQuantityValue
        : this.currentQuantityValue === this.max
        ? this.max
        : this.currentQuantityValue + 1
    },
    decreaseQuantity() {
      this.currentQuantity = this.readOnly
        ? this.currentQuantityValue
        : this.currentQuantityValue > this.min
        ? this.currentQuantityValue - 1
        : this.min
    },
  },
}
</script>

<style lang="scss" module>
.quantity {
  display: flex;
  align-items: center;
  justify-content: center;
  // margin-left: -0.578125rem;

  &-button {
    min-width: auto !important;
    // margin: 0 0.578125rem;

    padding: 0 !important;

    color: var(--primary);

    border: 1.5px solid var(--primary);
    border-radius: 50%;

    &:global(.theme--light.v-btn.v-btn--disabled):disabled {
      color: var(--grey-lighten-1) !important;

      border-color: var(--grey-lighten-1) !important;
      cursor: not-allowed;
    }
  }

  &-label {
    &:after,
    &:before {
      position: absolute;
      top: 50%;
      left: 50%;

      display: block;

      background: var(--primary);
      transform: translate(-50%, -50%);

      content: '';
    }

    &.increase {
      &:after {
        width: 0.9375rem;
        height: 2px;
      }

      &:before {
        width: 2px;
        height: 0.9375rem;
      }
    }

    &.decrease {
      &:after {
        width: 0.9375rem;
        height: 2px;
      }
    }
  }

  &-button:disabled .quantity-label {
    &:after,
    &:before {
      background: var(--grey-lighten-1);
    }
  }

  &-input {
    min-width: 2.5rem;
    height: 1.875rem;

    font-family: var(--font-mono);

    text-align: center;

    border: 1.5px solid var(--primary);
    outline: 0 none;

    -moz-appearance: textfield;

    &:disabled {
      border: 1.5px solid var(--grey-lighten-1);
    }

    &::-webkit-outer-spin-button,
    &::-webkit-inner-spin-button {
      margin: 0;

      -webkit-appearance: none;
    }
  }
}
</style>
